import { NgModule } from '@angular/core';
import { SharedModule } from './shared.module';

import { DashboardComponent } from '../components/ehr/dashboard/dashboard.component';
import { DashboardInpatientByAgeComponent } from '../components/ehr/dashboard/dashboard-inpatient-by-age/dashboard-inpatient-by-age.component';
import { DashboardInpatientByGenderComponent } from '../components/ehr/dashboard/dashboard-inpatient-by-gender/dashboard-inpatient-by-gender.component';
import { DashboardBedAvailabilityByWardComponent } from '../components/ehr/dashboard/dashboard-bed-availability-by-ward/dashboard-bed-availability-by-ward.component';
import { DashboardBedAvailabilityByDayComponent } from '../components/ehr/dashboard/dashboard-bed-availability-by-day/dashboard-bed-availability-by-day.component';
import { DashboardAdmissionReasonComponent } from '../components/ehr/dashboard/dashboard-admission-reason/dashboard-admission-reason.component';
import { DashboardAdmissionsAndDischargesComponent } from '../components/ehr/dashboard/dashboard-admissions-and-discharges/dashboard-admissions-and-discharges.component';
import { DashboardDischargeTypesComponent } from '../components/ehr/dashboard/dashboard-discharge-types/dashboard-discharge-types.component';
import { DashboardAmenComponent } from '../components/ehr/dashboard-amen/dashboard-amen.component';
import { DashboardInpatientByOlderAgeComponent } from '../components/ehr/dashboard-amen/dashboard-inpatient-by-older-age/dashboard-inpatient-by-older-age.component';
import { DashboardMohDmswComponent } from '../components/ehr/dashboard-amen/dashboard-moh-dmsw/dashboard-moh-dmsw.component';
import { DashboardAdmissionsMohDmswComponent } from '../components/ehr/dashboard-amen/dashboard-admissions-moh-dmsw/dashboard-admissions-moh-dmsw.component';
import { DashboardRegistrationHistoryDateComponent } from '../components/ehr/dashboard-amen/dashboard-registration-history-date/dashboard-registration-history-date.component';
import { DashboardRegistrationHistoryMonthComponent } from '../components/ehr/dashboard-amen/dashboard-registration-history-month/dashboard-registration-history-month.component';
import { DashboardAverageRegistrationStatusTimesComponent } from '../components/ehr/dashboard-amen/dashboard-average-registration-status-times/dashboard-average-registration-status-times.component';
import { DashboardAdmissionsByGenderComponent } from '../components/ehr/dashboard/dashboard-admissions-by-gender/dashboard-admissions-by-gender.component';
import { DashboardAdmissionsByOlderAgeComponent } from '../components/ehr/dashboard-amen/dashboard-admissions-by-older-age/dashboard-admissions-by-older-age.component';
import { DashboardAdmissionsPerReasonComponent } from '../components/ehr/dashboard-amen/dashboard-admissions-per-reason/dashboard-admissions-per-reason.component';

@NgModule({
  declarations: [
    DashboardComponent,
    DashboardInpatientByAgeComponent,
    DashboardInpatientByGenderComponent,
    DashboardBedAvailabilityByWardComponent,
    DashboardBedAvailabilityByDayComponent,
    DashboardAdmissionReasonComponent,
    DashboardAdmissionsAndDischargesComponent,
    DashboardDischargeTypesComponent,
    DashboardAmenComponent,
    DashboardInpatientByOlderAgeComponent,
    DashboardMohDmswComponent,
    DashboardAdmissionsMohDmswComponent,
    DashboardRegistrationHistoryDateComponent,
    DashboardRegistrationHistoryMonthComponent,
    DashboardAverageRegistrationStatusTimesComponent,
    DashboardAdmissionsByGenderComponent,
    DashboardAdmissionsByOlderAgeComponent,
    DashboardAdmissionsPerReasonComponent,
  ],
  imports: [SharedModule],
  exports: [
    DashboardComponent,
    DashboardInpatientByAgeComponent,
    DashboardInpatientByGenderComponent,
    DashboardBedAvailabilityByWardComponent,
    DashboardBedAvailabilityByDayComponent,
    DashboardComponent,
    DashboardInpatientByAgeComponent,
    DashboardInpatientByGenderComponent,
    DashboardBedAvailabilityByWardComponent,
    DashboardBedAvailabilityByDayComponent,
    DashboardAdmissionReasonComponent,
    DashboardAdmissionsAndDischargesComponent,
    DashboardDischargeTypesComponent,
    DashboardAmenComponent,
    DashboardInpatientByOlderAgeComponent,
    DashboardMohDmswComponent,
    DashboardAdmissionsMohDmswComponent,
    DashboardRegistrationHistoryDateComponent,
    DashboardRegistrationHistoryMonthComponent,
    DashboardAverageRegistrationStatusTimesComponent,
    DashboardAdmissionsByGenderComponent,
    DashboardAdmissionsByOlderAgeComponent,
    DashboardAdmissionsPerReasonComponent,
  ],
})
export class DashboardModule {}
